import React from "react";
import Instagram from "../../assets/instagram.png";
import Facebook from "../../assets/facebook.png";

import "./styles.scss";

const Footer = () => {
  return (
    <section id="footerSection">
      <div className="footerContainer">
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "50px",
          }}
        >
          <div style={{ display: "flex" }} className="socialRow">
            <img
              src={Instagram}
              alt="instagram"
              style={{ width: "25px", height: "25px" }}
            />
            <div
              style={{
                textAlign: "center",
                justifySelf: "center",
                marginTop: "5px",
              }}
            >
              Instagram
            </div>
          </div>
          <div style={{ display: "flex" }} className="socialRow">
            <img
              src={Facebook}
              alt="facebook"
              style={{ width: "25px", height: "25px" }}
            />
            <div
              style={{
                textAlign: "center",
                justifySelf: "center",
                marginTop: "5px",
              }}
            >
              Facebook
            </div>
          </div>
        </div>
      </div>
      <div>Alex Horatiu Moldovan @2024 All Rights Reserved</div>
    </section>
  );
};

export default Footer;
